import * as React from 'react';
/**
 * @hidden
 */
export var ColumnMenuItem = function (props) {
    return (React.createElement("div", { onClick: props.onClick, className: "k-columnmenu-item" + (props.selected ? ' k-state-selected' : '') },
        props.iconClass && React.createElement("span", { className: "k-icon" + (props.iconClass ? ' ' + props.iconClass : '') }),
        props.title));
};
//# sourceMappingURL=ColumnMenuItem.js.map